import { formatBytes } from '@/utils/formatBytes';

interface DocumentSummaryBarProps {
  fileName: string;
  fileSizeBytes: number;
  pageCount: number;
  onChangeDocument: () => void;
}

export function DocumentSummaryBar({
  fileName,
  fileSizeBytes,
  pageCount,
  onChangeDocument,
}: DocumentSummaryBarProps) {
  return (
    <div className="bg-surface-lowest rounded-4 shadow-kiosk-sm p-3 d-flex align-items-center justify-content-between d-lg-none">
      <div className="d-flex align-items-center gap-2 min-w-0">
        <div
          className="rounded-3 bg-surface-high d-flex align-items-center justify-content-center text-primary flex-shrink-0"
          style={{ width: 44, height: 44 }}
        >
          <i className="bi bi-file-earmark-pdf" style={{ fontSize: 22 }} />
        </div>
        <div className="d-flex flex-column min-w-0">
          <span className="text-label-md text-on-surface text-truncate">{fileName}</span>
          <div className="d-flex align-items-center gap-1 text-on-surface-variant text-body-sm">
            <span>{pageCount > 0 ? `${pageCount} Pages` : 'Pages —'}</span>
            <span style={{ fontSize: 10 }}>•</span>
            <span>{formatBytes(fileSizeBytes)}</span>
            <span style={{ fontSize: 10 }}>•</span>
            <span className="text-success text-label-sm">Ready</span>
          </div>
        </div>
      </div>
      <button
        type="button"
        aria-label="Change document"
        className="btn bg-surface-low rounded-3 tap-target active-press border-0 text-primary flex-shrink-0"
        onClick={onChangeDocument}
      >
        <i className="bi bi-pencil" />
      </button>
    </div>
  );
}
